import { Keyframe, WeightedMode } from "./Keyframe";
export class FloatKeyframe extends Keyframe {
    constructor() {
        super();
        this.inWeight = Keyframe.defaultWeight;
        this.outWeight = Keyframe.defaultWeight;
        this.weightedMode = WeightedMode.None;
    }
    cloneTo(destObject) {
        super.cloneTo(destObject);
        destObject.inTangent = this.inTangent;
        destObject.outTangent = this.outTangent;
        destObject.value = this.value;
        destObject.inTangent = this.inTangent;
        destObject.outTangent = this.outTangent;
        destObject.value = this.value;
        destObject.inWeight = this.inWeight;
        destObject.outWeight = this.outWeight;
        destObject.weightedMode = this.weightedMode;
    }
    clone() {
        let f = new FloatKeyframe();
        this.cloneTo(f);
        return f;
    }
}
